import { inject } from '@angular/core';
import { InMemoryScrollingOptions, NavigationError, RedirectCommand, Router, RouterConfigOptions } from '@angular/router';
import { PlatformService } from '@rma/public/generic/util/environment';

export const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
};

export const routerConfig: RouterConfigOptions = {
  onSameUrlNavigation: 'reload',
  paramsInheritanceStrategy: 'always',
  urlUpdateStrategy: 'eager',
  canceledNavigationResolution: 'computed',
};

const ERROR_PAGE_URL = '/internal-error';

// On the server a failed navigation leaves nothing to render, so the error page answers at the failing URL.
// The browser keeps the rejection, which the ErrorHandler needs to reload a tab whose chunks a deploy removed.
export function redirectNavigationErrorToErrorPage(error: NavigationError): RedirectCommand | void {
  if (!inject(PlatformService).isPlatformServer) {
    return;
  }

  console.error(`NAVIGATION ERROR | ${error.url}`, error.error);

  // Redirecting a failed error page would retry it forever.
  if (error.url === ERROR_PAGE_URL) {
    return;
  }

  return new RedirectCommand(inject(Router).parseUrl(ERROR_PAGE_URL), { skipLocationChange: true });
}

//https://github.com/angular/angular/issues/51601  scrollOffset: [0, 64], setOffset()
